module.exports = __webpack_public_path__ + "h5/img/intrduce.7ad1f04a.png";